import Event from "@/models/Event";
import {getEventDoc, getSpeakerDoc} from "@/shared/firebase_utils";

const state = {
  currentSession: null,
  currentSpeaker: null,
};

const getters = {
  currentSession: (state) => state.currentSession,
  currentSpeaker: (state) => state.currentSpeaker
};

const actions = {
  async setCurrentSession({ commit }, payload) {
    await commit("setCurrentSession", payload);
  },
  async setCurrentSpeaker({ commit }, payload) {
    await commit("setCurrentSpeaker", payload);
  },
  async initializeSpeaker({ commit }, speakerId) {
    try {
        let doc = await getSpeakerDoc(speakerId);
        commit("setCurrentSpeaker", doc.data());
    } catch (error) {
      console.log("Error initialising speaker: ", error);
    }
  },
  async initializeEvent({ commit }, eventId) {
    try {
      //Read data from firestore
      let doc = await getEventDoc(eventId);
      commit("setCurrentSession", Event.fromFireStore(doc));
    } catch (error) {
      console.log("Error initialising sub-event: ", error);
    }
  },
  clearCurrentSession({commit}){
    commit("clearCurrentSession");
  },
  async clearCurrentSpeaker({ commit }) {
    await commit("clearCurrentSpeaker");
  },
};

const mutations = {
    setCurrentSession: (state, currentSession) => {
    state.currentSession = currentSession;
  },
  clearCurrentSession: (state) => {
    state.currentSession = null;
  },
  setCurrentSpeaker: (state, currentSpeaker) => {
    state.currentSpeaker = currentSpeaker;
  },
    clearCurrentSpeaker: (state) => {
        state.currentSpeaker = null;
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
